import { TerminalScreen } from "./terminal-screen"

import { formatTerminalReason } from "../lib/error-messages"

export function KickedScreen({ reason }: { reason: string }) {
  return <TerminalScreen {...formatTerminalReason(reason)} />
}
